import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children, openRequestModal }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar openRequestModal={openRequestModal} />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
